import * as React from "react";

import useModalState from "app/hooks/useModalState";
import storage from "app/lib/storage";
import { ANNOUNCEMENTS_KEY } from "app/constants/variables";

import AnnouncementModal from "./AnnouncementModal";
import { useProfile } from "app/providers/ProfileProvider";
import { useActiveProfile } from "app/providers/ActiveProfileProvider";
import useGetBanners from "app/hooks/useGetBanners";

export default function Announcement() {
  const userCountry = useProfile();
  const activeProfile = useActiveProfile();

  const { isOpen, setIsOpen, closeModal } = useModalState();

  const { banners } = useGetBanners();

  const announcements = React.useMemo(
    () => banners?.filter((r) => r.category === "announcements") ?? [],
    [banners, activeProfile?.profile_type]
  );

  const viewedAnnouncements = React.useMemo(
    () => storage.get(ANNOUNCEMENTS_KEY) ?? {},
    []
  );

  const unSeenAnnouncement = React.useMemo(
    () =>
      announcements.filter(
        (item) => !Object.keys(viewedAnnouncements).includes(item.id)
      ),
    [viewedAnnouncements, announcements]
  );

  const announcement = unSeenAnnouncement;

  const announcementStore = storage.get(ANNOUNCEMENTS_KEY) as Record<
    string,
    string
  >;

  const dismissedAnnouncements = {
    ...announcementStore,
  };

  const lastAnnouncement = announcement[announcement.length - 1];

  const isDismissed = Object.keys(dismissedAnnouncements).includes(
    lastAnnouncement?.id ?? ""
  );

  const onClose = () => {
    closeModal();
    setTimeout(
      () =>
        storage.set(ANNOUNCEMENTS_KEY, {
          ...dismissedAnnouncements,
          [lastAnnouncement?.id as string]: lastAnnouncement?.id,
        }),
      1000
    );
  };

  return (
    <>
      {announcement.length > 0 && (
        <AnnouncementModal
          isDismissed={isDismissed}
          open={isOpen}
          setIsOpen={setIsOpen}
          onClose={onClose}
          config={announcement}
        />
      )}
    </>
  );
}
